<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      :class="props.hoverAble && 'hover-fill'"
      clip-rule="evenodd"
      d="M17.2197 3.3746C17.4029 3.14621 17.6844 3 18 3C18.0014 3 18.0028 3 18.0042 3.00001C18.2222 2.9991 18.4404 3.06899 18.6214 3.2097L18.7156 3.29289L22.7156 7.29289C23.1061 7.68342 23.1061 8.31658 22.7156 8.70711C22.3551 9.06759 21.7879 9.09532 21.3956 8.7903L21.3014 8.70711L19 6.40594V19C19 19.5523 18.5523 20 18 20C17.4872 20 17.0645 19.614 17.0067 19.1166L17 19V6.42219L14.7379 8.68475C14.3774 9.04523 13.8102 9.07296 13.4179 8.76793L13.3237 8.68475C12.9632 8.32426 12.9355 7.75703 13.2405 7.36474L13.3237 7.27053L17.2197 3.3746Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      :class="props.hoverAble && 'hover-fill'"
      clip-rule="evenodd"
      d="M8.00026 3C8.36359 3 8.69485 3.19662 8.87066 3.5076L8.92334 3.61538L11.4233 9.61538C11.6358 10.1252 11.3947 10.7107 10.8849 10.9231C10.4115 11.1203 9.87285 10.9265 9.62825 10.4897L9.57718 10.3846L9.00026 9H6.00026L5.42334 10.3846C5.22609 10.858 4.70718 11.0997 4.22588 10.9617L4.11565 10.9231C3.64226 10.7258 3.40058 10.2069 3.53854 9.72562L3.57718 9.61538L6.07718 3.61538C6.21693 3.28 6.52583 3.04985 6.88051 3.00717L7.00026 3H8.00026ZM7.50026 5.4L8.16693 7H6.83359L7.50026 5.4ZM11.4935 13.8834C11.4358 13.386 11.0131 13 10.5003 13H4.50026L4.38364 13.0067C3.8863 13.0645 3.50026 13.4872 3.50026 14L3.50699 14.1166C3.56475 14.614 3.98742 15 4.50026 15H7.86826L3.91051 17.8914L3.81886 17.9671C3.61696 18.155 3.50026 18.4197 3.50026 18.699V19L3.50699 19.1166C3.56475 19.614 3.98742 20 4.50026 20H10.5003L10.6169 19.9933C11.1142 19.9355 11.5003 19.5128 11.5003 19L11.4935 18.8834C11.4358 18.386 11.0131 18 10.5003 18H7.15126L11.09 15.125L11.1817 15.0493C11.3836 14.8614 11.5003 14.5967 11.5003 14.3174V14L11.4935 13.8834Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
